query allBookmakers {
  allBookmakerGateways {
    bookmakers: nodes {
      displayName
      source
      gateway
    }
  }
}
